jQuery(document).ready(function ($) {
  const $slides = $(".timeline-slide");
  const $dots = $(".year-dot");
  let current = 0;

  function updateSlider(index) {
    if (index < 0) index = 0;
    if (index >= $slides.length) index = $slides.length - 1;

    current = index;

    // Reset
    $slides.removeClass("active prev next");
    $dots.removeClass("active show");

    // Active slide
    $slides.eq(current).addClass("active");
    $dots.eq(current).addClass("active show");

    // Previous slide
    if (current - 1 >= 0) {
      $slides.eq(current - 1).addClass("prev");
      $dots.eq(current - 1).addClass("show");
    }

    // Next slide
    if (current + 1 < $slides.length) {
      $slides.eq(current + 1).addClass("next");
      $dots.eq(current + 1).addClass("show");
    }
  }

  updateSlider(0);

  $(".next-year").on("click", function () {
    updateSlider(current + 1);
  });

  $(".prev-year").on("click", function () {
    updateSlider(current - 1);
  });

  $dots.on("click", function () {
    updateSlider($(this).index());
  });
  /* ---------- Desktop Hover Dropdown Handling (Already Present) ---------- */
  const menuItems = $(".header-nav li.menu-item-has-children");
  menuItems.each(function () {
    const item = $(this);
    const link = item.children("a");
    link.on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      item.siblings(".menu-item-has-children.open").removeClass("open");
      item.toggleClass("open");
    });
  });

  $(document).on("click", function (e) {
    if (!$(e.target).closest(".header-nav").length) {
      menuItems.removeClass("open");
    }
  });

  /* ---------- Mobile Menu SubMenu Toggle START ---------- */
  $(".header-mobile-menu .menu-item-has-children > a").on(
    "click",
    function (e) {
      e.preventDefault();
      e.stopPropagation(); // Prevent event from bubbling to parent menus

      var _this = $(this).closest(".menu-item");
      var parentMenu = _this.closest(".sub-menu");

      if (_this.hasClass("active")) {
        _this.removeClass("active");
        _this.find("> .sub-menu").slideUp(); // Only target direct child submenu
      } else {
        // Only close sibling menus at the same level, not parent menus
        if (parentMenu.length > 0) {
          // If this is a nested menu, only close siblings within the same parent
          parentMenu.find("> li.menu-item").not(_this).removeClass("active");
          parentMenu
            .find("> li.menu-item")
            .not(_this)
            .find("> .sub-menu")
            .slideUp();
        } else {
          // If this is a top-level menu, close other top-level menus
          $(".header-mobile-menu > .header-navbar > ul > li.menu-item")
            .not(_this)
            .removeClass("active");
          $(".header-mobile-menu > .header-navbar > ul > li.menu-item")
            .not(_this)
            .find("> .sub-menu")
            .slideUp();
        }

        _this.addClass("active");
        _this.find("> .sub-menu").first().slideDown(); // Only target direct child submenu
      }
    },
  );
  /* ---------- Mobile Menu SubMenu Toggle END ---------- */

  /* ---------- Your Accordion JS (Leave as is unless linked to menu) ---------- */
  $(".accordion-header").on("click", function () {
    var item = $(this).closest(".accordion-item");

    $(".accordion-item")
      .not(item)
      .removeClass("active")
      .find(".accordion-content")
      .slideUp();
    item.toggleClass("active");
    item.find(".accordion-content").slideToggle();
  });

  /* ---------- Lightbox ---------- */
  const lightbox = GLightbox({
    selector: ".glightbox",
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
  });

  /* ---------- Header Sticky Scroll ---------- */
  $(window).on("scroll", function () {
    $(".header-main").toggleClass("scrolled", $(window).scrollTop() > 0);
  });

  /* ---------- Mobile Hamburger Toggle ---------- */
  $(".hamburger").on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(".header-main").toggleClass("menu-open");
    $(".header-mobile-menu").toggleClass("active");
  });
  $(".archive-menu a").on("click", function () {
    $(".archive-menu a").removeClass("active");
    $(this).addClass("active");
  });

  $(".mobile-readmore").each(function () {
    var $paragraph = $(this);
    var $codeTag = $paragraph.find("code");

    if ($codeTag.length) {
      var $readMoreBtn = $('<span class="read-more-btn">Read More...</span>');
      $codeTag.after($readMoreBtn);
      $readMoreBtn.on("click", function () {
        if ($paragraph.hasClass("collapsed")) {
          $paragraph.removeClass("collapsed");
          $(this).hide();
          $codeTag.slideDown(300);
        } else {
          $paragraph.addClass("collapsed");
          $(this).show();
          $codeTag.slideUp(300);
        }
      });
    }
  });

  // Toggle dropdown on button click
  $(".ad__toggle").on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(this).siblings(".ad__dropdown").slideToggle();
  });

  // Close dropdown when clicking outside
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".archive-dropdown").length) {
      $(".ad__toggle").removeClass("active");
      $(".ad__dropdown").slideUp();
    }
  });

  // Close dropdown when clicking on a link
  $(".add__item").on("click", function () {
    $(".ad__toggle").removeClass("active");
    $(".ad__dropdown").slideUp();
  });
});
